var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29315",
    "data-name": "Group 29315",
    transform: "translate(-515.942 -189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29313",
    "data-name": "Group 29313",
    transform: "translate(-730.058 11492.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1246 -11303.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29314",
    "data-name": "Group 29314",
    transform: "translate(76.7 -806.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50364",
    "data-name": "Path 50364",
    d: "M427.494,173.215v-.576a.207.207,0,0,0-.141-.2l-1.861-.62a.207.207,0,0,0-.272.2v1.2Z",
    transform: "translate(47.934 837.708)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50365",
    "data-name": "Path 50365",
    d: "M31.72,300.527H26.413a.379.379,0,0,1-.379-.379v-.758H31.72Z",
    transform: "translate(429.682 715.703)",
    fill: "#8d8a94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50366",
    "data-name": "Path 50366",
    d: "M18.555,283.171h-9.5a.379.379,0,0,1-.379-.379v-.758H21.187l-1.954.977A1.516,1.516,0,0,1,18.555,283.171Z",
    transform: "translate(446.28 732.301)",
    fill: "#a7a5ac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 1.137,
    cy: 1.137,
    r: 1.137,
    transform: "translate(459.507 1014.714)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 0.569,
    cy: 0.569,
    r: 0.569,
    transform: "translate(460.075 1015.283)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 1.137,
    cy: 1.137,
    r: 1.137,
    transform: "translate(457.232 1014.714)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 0.569,
    cy: 0.569,
    r: 0.569,
    transform: "translate(457.801 1015.283)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50367",
    "data-name": "Path 50367",
    d: "M321.085,290.712h8.339v1.516h-8.339Z",
    transform: "translate(147.519 724.002)",
    fill: "#b9b7bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 1.137,
    cy: 1.137,
    r: 1.137,
    transform: "translate(469.741 1014.714)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_491",
    "data-name": "Ellipse 491",
    cx: 0.569,
    cy: 0.569,
    r: 0.569,
    transform: "translate(470.31 1015.283)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 1.137,
    cy: 1.137,
    r: 1.137,
    transform: "translate(467.467 1014.714)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 0.569,
    cy: 0.569,
    r: 0.569,
    transform: "translate(468.036 1015.283)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50368",
    "data-name": "Path 50368",
    d: "M429.011,200.182h-1.9v-.758h-1.9v-4.17H428.3a.379.379,0,0,1,.376.332l.264,2.115a9.483,9.483,0,0,1,.073,1.175Z",
    transform: "translate(47.933 815.291)",
    fill: "#ff9164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50369",
    "data-name": "Path 50369",
    d: "M468.61,290.712h1.9v.758h-1.9Z",
    transform: "translate(6.438 724.002)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 1.137,
    cy: 1.137,
    r: 1.137,
    transform: "translate(473.911 1014.714)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 0.569,
    cy: 0.569,
    r: 0.569,
    transform: "translate(474.48 1015.283)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50370",
    "data-name": "Path 50370",
    d: "M443.713,212.61h-.948a.19.19,0,0,0-.19.189v1.1a.284.284,0,0,0,.223.277l.915.2Z",
    transform: "translate(31.335 798.693)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50371",
    "data-name": "Path 50371",
    d: "M445.535,214.3l-.211-1.689h-2.559a.19.19,0,0,0-.19.189v1.1a.284.284,0,0,0,.223.277l2.783.618C445.57,214.629,445.556,214.464,445.535,214.3Z",
    transform: "translate(31.335 798.693)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50372",
    "data-name": "Path 50372",
    d: "M468.61,214.379l1.869.415c-.012-.165-.026-.331-.046-.5l-.211-1.689H468.61Z",
    transform: "translate(6.438 798.693)",
    fill: "#625d6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50373",
    "data-name": "Path 50373",
    d: "M.379,169.22H17.816a.379.379,0,0,1,.379.379v4.549a.379.379,0,0,1-.379.379H.379A.379.379,0,0,1,0,174.148V169.6a.379.379,0,0,1,.379-.379Z",
    transform: "translate(454.579 840.188)",
    fill: "#ffb47d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50374",
    "data-name": "Path 50374",
    d: "M33.655,256.757H17.734a.379.379,0,1,1,0-.758H33.655a.379.379,0,1,1,0,.758Z",
    transform: "translate(437.982 757.199)",
    fill: "#ff9164"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckHighlighted);
export default __webpack_public_path__ + "static/media/truckHighlighted.8d297aa77a71bbe2012442ff520acf3e.svg";
export { ForwardRef as ReactComponent };